import React from 'react';
import Modal from '../shared/Modal';
import FormsySimpleInput from '../form/FormsySimpleInput';
import Formsy from 'formsy-react';
import { menuAPI } from '../../InterfaceAPI/menuAPI';
import { maskRichText } from '../../masks';
import { isOccasion } from '../../helpers/serviceUtil';

class ServiceAddMenuModal extends React.Component {
  state = {
    lastTerm: '',
    searchTerm: '',
    isLoading: false,
    menus: []
  };

  render() {
    const { handleSearch, loadMenus } = this;
    const { isOpen, closeModal } = this.props;
    const { searchTerm } = this.state;
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        className="modal modal--no-padding admin-wrapper"
      >
        <div className="modal__head modal__head--flush-bottom">
          <h2 className="h2 modal__heading">Add a Menu</h2>
          <Formsy className="form" onValidSubmit={loadMenus}>
            <div className="cms__bar cms__bar--margin-bot">
              <div className="cms__bar-item cms__bar-item--full">
                <FormsySimpleInput
                  type="text"
                  name="searchTerm"
                  placeholder="Enter Menu Name"
                  className="simple-input simple-input--pad-right"
                  value={searchTerm}
                  onChange={handleSearch}
                  autoComplete="off"
                />
              </div>
              <div className="cms__bar-item">
                <input
                  type="submit"
                  value="Search"
                  className="btn btn--solid-blue"
                />
              </div>
            </div>
          </Formsy>
        </div>
        <div className="modal__body modal__body--tall">
          <div className="add-menu">{this.renderMenus()}</div>
        </div>
      </Modal>
    );
  }

  renderMenus() {
    const { menus, lastTerm } = this.state;
    if (menus.length === 0)
      return (
        <div className="add-menu__results menu__results--empty">
          <p className="p">
            Enter a menu name to see results to add to the service.
          </p>
        </div>
      );
    else
      return (
        <div className="add-menu__results">
          <div className="add-menu__results-count">
            <span className="p p--bold">{menus.length} Results </span>
            {lastTerm !== '' ? `for "${lastTerm}"` : ''}
          </div>
          <div className="add-menu__list">
            {menus.map(menu => this.renderMenu(menu))}
          </div>
        </div>
      );
  }

  renderMenu(menu) {
    const { id, name = '', notes = '' } = menu;
    return (
      <div
        key={id}
        className="add-menu__item"
        onClick={() => this.addMenu(menu)}
      >
        {name}{' '}
        <span className="add-menu__item--notes">{maskRichText(notes)}</span>
      </div>
    );
  }

  handleSearch = e => {
    this.setState({ searchTerm: e.target.value });
  };

  addMenu = menu => {
    this.props.updateService({ menu }, { isMenuEdit: true });
  };

  loadMenus = () => {
    const { searchTerm: name } = this.state;
    // service types containing occasion will search occasion menus- e.g marketing_occasion
    let occurrence = this.props.serviceType;
    if (isOccasion(this.props.service)) {
      occurrence = ['occasion', 'company'];
    }
    const search = { name: name, occurrence };

    // clear existing
    this.setState({ menus: [], isLoading: true });

    // make request
    menuAPI
      .searchMenus({ page: 1, search })
      .then(({ menus }) =>
        this.setState({ menus, isLoading: false, lastTerm: name })
      )
      .catch(error => console.log(error));
  };
}

export default ServiceAddMenuModal;



// WEBPACK FOOTER //
// ./src/components/service/ServiceAddMenuModal.js